import { useEffect } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { cleanObj } from '../../../../../../shared/utils/objects';
import { PqrProductData } from '../../../../../../shared/types/modules/pqr';
import { PqrProductDataProps } from './props';

export const usePqrProductData = ({
    data,
    onChangeData,
    onChangeFormik,
}: PqrProductDataProps) => {
    const onSubmit = (data: PqrProductData) => {
        if (onChangeData)
            onChangeData(cleanObj(data) || ({} as PqrProductData));
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('policy', data?.policy || '');
        formik?.setFieldValue('bonusValue', data?.bonusValue || '');
        formik?.setFieldValue('plate', data?.plate || '');
    }, [data]);

    return {
        formik,
    };
};
